<template>
  <main-layout>
    <loading-screen v-if="isLoading" />
    <div>
      <exclamation-circle
        scale="3"
        color="red"
      />
    </div>

    <p class="text-xl">
      {{ $t('recurrence.active.text', { msisdn }) }}
      {{ $t('recurrence.active.date', { date }) }}
    </p>

    <button
      id="changeAffiliation"
      class="button text-2xl"
      @click="changeAffiliation"
    >
      Cambios en afiliación
    </button>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import jwt from 'jwt-decode';
import storage from '@lagersoft/key-storage';
import MainLayout from '@/components/MainLayout';
import { ExclamationCircle } from '@/components/icons';
import { dateFormatter } from '@/filters';

export default {
  name: 'ActiveRecurrenceInfo',
  components: { MainLayout, ExclamationCircle },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(['country']),
    msisdn() {
      return jwt(storage.get('tokenIvr')).number.replace(this.country.lada, '') || '';
    },
    date() {
      return dateFormatter(this.$route?.query?.date || new Date());
    }
  },
  methods: {
    changeAffiliation() {
      this.isLoading = true;
      global.api
        .mpcUpdateRecurrence()
        .then((response) => {
          this.isLoading = false;
          if (response.status === 200) {
            this.$emit('changeAffiliation');
          } else {
            this.$router.push({
              name: 'Error',
              query: { error: 'GENERIC_ERROR' }
            });
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.$router.push({
            name: 'Error',
            query: { error: 'GENERIC_ERROR' }
          });
        });
    }
  }
};
</script>
